<template>
  <div class="report-set-list">
    <div class="page_title">报表配置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="margin-bottom: 20px">
          <el-button type="primary" icon="el-icon-plus" @click="addReport"
            >添加报表</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="reportTableRef"
            class="report-table"
            :data="reportTableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              align="center"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'type'" class="report-status">
                  <i :style="{ backgroundColor: '#78A574' }"></i>
                  {{ scope.row[item.prop] | typeText }}
                </div>

                <div v-else-if="item.prop == 'icon'">
                  <el-image
                    style="width: 163px; height: 100px"
                    :src="scope.row[item.prop]"
                    :preview-src-list="[scope.row[item.prop]]"
                  >
                  </el-image>
                </div>

                <div v-else-if="item.prop == 'status'" class="report-status">
                  <i
                    :style="
                      scope.row[item.prop] == 2
                        ? { backgroundColor: '#1ABC9C' }
                        : { backgroundColor: '#FF0000' }
                    "
                  ></i>
                  {{ scope.row[item.prop] | stateText }}
                </div>

                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="300px" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status == 1"
                  @click="reportEdit(scope.row)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('525')
                      : false
                  "
                  size="medium"
                  >编辑</el-button
                >

                <el-button
                  v-if="scope.row.status != 1"
                  @click="reportDetail(scope.row)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('525')
                      : false
                  "
                  size="medium"
                  >详情</el-button
                >

                <el-button
                  v-if="scope.row.status == 1"
                  @click="changeStatus(scope.row, 2)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('527')
                      : false
                  "
                  size="medium"
                  >发布</el-button
                >

                <el-button
                  v-if="scope.row.status != 1"
                  @click="changeStatus(scope.row, 1)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('527')
                      : false
                  "
                  size="medium"
                  >下架</el-button
                >

                <el-button
                  v-if="scope.row.status == 1"
                  @click="reportDel(scope.row)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('526')
                      : false
                  "
                  size="medium"
                  >删除</el-button
                >
              </template>
            </el-table-column>

            <el-table-column label="排序" align="center">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="置顶"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row, 1)"
                    size="medium"
                    type="text"
                    icon="el-icon-upload2"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('524')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="置底"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row, 4)"
                    size="medium"
                    type="text"
                    icon="el-icon-download"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('524')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="上移"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row, 2)"
                    size="medium"
                    type="text"
                    icon="el-icon-top"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('524')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="下移"
                  placement="top"
                >
                  <el-button
                    @click="updateSort(scope.row, 3)"
                    size="medium"
                    type="text"
                    icon="el-icon-bottom"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('524')
                        : false
                    "
                    style="font-size: 20px"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="searchList"
        />
      </div>
    </div>
  </div>
</template>
<script>
import imgtext from "../../../api/imgtext";
import Pagination from "../../../components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tableHeader: [
        {
          label: "报表名称",
          prop: "report_name",
          width: "auto",
        },
        {
          label: "路由名称",
          prop: "route_url",
          width: "auto",
        },
        {
          label: "类别",
          prop: "type",
          width: "80px",
        },
        {
          label: "图标",
          prop: "icon",
          width: "300px",
        },
        {
          label: "状态",
          prop: "status",
          width: "80px",
        },
      ],
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      detail: {},
      edit: false,
      reportTableData: [],
    };
  },
  filters: {
    stateText(val) {
      switch (val) {
        case 1:
          return "下架";
        case 2:
          return "发布";
        default:
          return val;
      }
    },
    typeText(val) {
      switch (val) {
        case 1:
          return "原生";
        case 2:
          return "H5";
        default:
          return val;
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取报表列表
    getList() {
      imgtext.getReportList(this.pagination).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          if (!data.list.length && this.pagination.page > 1) {
            this.pagination.page = this.pagination.page - 1;
            this.getList();
          }
          this.totalNum = data.total;
          if (data.list.length == 0) {
            this.pagination.page = this.pagination.page - 1;
            this.getList();
          } else {
            this.reportTableData = data.list;
          }
        }
      });
    },
    searchList() {
      this.getList();
    },
    //排序
    updateSort(data, sort) {
      if (this.totalNum == 1) {
        this.$message.warning("只有一条数据哦");
        return;
      }
      let params = {
        report_id: data.report_id,
        sort,
      };
      imgtext.editReportSort(params).then((res) => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    //添加
    addReport() {
      this.$router.push({
        path: "/home/imgtext/reportEditor",
        query: {
          report_id: 0,
        },
      });
    },
    // 编辑
    reportEdit(data) {
      let query = _.omit(data, ["sort", "is_delete", "create_time"]);
      this.$router.push({
        path: "/home/imgtext/reportEditor",
        query,
      });
    },
    // 详情
    reportDetail(data) {
      // console.log(data);
      let query = _.omit(data, ["sort", "is_delete", "create_time"]);
      this.$router.push({
        path: "/home/imgtext/reportEditor",
        query,
      });
    },
    // 发布/下架
    changeStatus(data, status) {
      let params = Object.assign(_.pick(data, ["report_id"]), { status });
      imgtext.changeReportStatus(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("发布成功");
          this.getList();
        }
      });
    },
    // 删除
    reportDel(data) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        imgtext.deleteReportInfo({ report_id: data.report_id }).then((res) => {
          let { code } = res;
          if (code == 0) {
            this.$message.success("删除成功");
            this.getList();
          }
        });
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.report-set-list {
  .pagination-container {
    display: flex;
    justify-content: center;
  }
  .report-table {
    .report-status {
      i {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 4px;
      }
    }
  }
}
</style>

